import loader from '../moduleLoader.js';
import animateScrollTo from 'animated-scroll-to';

function Premises(container) {
    function init() {
        initListingButtons();
        window.addEventListener('ResultUpdated', (e) => {
            updateButtons(parseInt(e.detail) > 0);
        });
       // var searchButton = document.getElementById("PremiseSearch-Button");
        if (typeof (searchButton) != 'undefined' && searchButton != null) {
            searchButton.addEventListener('click', (e) => {
                // Does this work in any occasion?
                e.preventDefault();
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'visa_lediga_lokaler_click',
                });

                updateListingType(false);
                const searchParams = new URLSearchParams(window.location.search);
                searchParams.set('search', 'true');
                history.replaceState(null, null, `?${searchParams.toString()}`);
            })
        }
    }

    function initListingButtons() {
        const buttonList = document.getElementById('premises-show-list');
        const buttonMap = document.getElementById('premises-show-map');
        const mapSvg = document.getElementById('map-icon').firstElementChild;
        const listSvg = document.getElementById('list-icon').firstElementChild;
        const searchParams = new URLSearchParams(window.location.search);

        if (searchParams.has('map') && searchParams.get('map') == 'true') {
            activateMapButton();
        } else {
            activateListButton();
        }

        if (buttonMap) {
            buttonMap.addEventListener('click', (e) => {
                e.preventDefault();
                searchParams.set('map', 'true');
                history.replaceState(null, null, `?${searchParams.toString()}`);
                updateListingType();
                activateMapButton();
            });
        }

        if(buttonList) {
            buttonList.addEventListener('click', (e) => {
                e.preventDefault();
                searchParams.delete('map');
                history.replaceState(null, null, `?${searchParams.toString()}`);
                updateListingType();
                activateListButton();
            });
        }
    }

    function updateButtons(hasResults) {
        const buttonList = document.getElementById('premises-show-list');
        const buttonMap = document.getElementById('premises-show-map');
        const searchParams = new URLSearchParams(location.search);

        //if(!hasResults) {
        //    buttonList.classList.add('hidden');
        //    buttonMap.classList.add('hidden');
        //}
        //else if (searchParams.has('map') && searchParams.get('map') == 'true') {
        //    buttonList.classList.remove('hidden');
        //    buttonMap.classList.add('hidden');
        //}
        //else {
        //    buttonList.classList.add('hidden');
        //    buttonMap.classList.remove('hidden');
        //}
    }

    function updateListingType() {
        animateScrollTo(document.getElementById('premises-result-container'), {speed: 900, offset: -102});

        const resultContainer = document.getElementById('premises-result-container').firstElementChild;
        const containerList = document.getElementsByClassName('premisesearch-page-result-list ')[0];
        const containerMap = document.getElementsByClassName('premisesearch-page__result__map ')[0];
        const searchParams = new URLSearchParams(location.search);
        resultContainer.classList.remove('hidden');

        if (searchParams.has('map') && searchParams.get('map') == 'true') {
            containerList.classList.add('hidden');
            containerMap.classList.remove('hidden');
        } else {
            containerList.classList.remove('hidden');
            containerMap.classList.add('hidden');
            //Quickfix for slider init when switching to list when initial mode is map.
            window.dispatchEvent(new Event('resize'));
        }
    }

    function activateMapButton() {
        const buttonList = document.getElementById('premises-show-list');
        const buttonMap = document.getElementById('premises-show-map');
        const mapSvg = document.getElementById('map-icon').firstElementChild;
        const listSvg = document.getElementById('list-icon').firstElementChild;
        mapSvg.style.fill = '#FFFFFF';
        listSvg.style.fill = '#6e1e82';
        var nodes = listSvg.childNodes;
        for (var i = 0; i < nodes.length; i++) {
            nodes[i].style.fill = '#6e1e82';
        }
        buttonList.classList.add('secondary');
        buttonMap.classList.remove('secondary');
    }

    function activateListButton() {
        const buttonList = document.getElementById('premises-show-list');
        const buttonMap = document.getElementById('premises-show-map');
        const mapSvg = document.getElementById('map-icon').firstElementChild;
        const listSvg = document.getElementById('list-icon').firstElementChild;
        listSvg.style.fill = '#FFFFFF';
        var nodes = listSvg.childNodes;
        for (var i = 0; i < nodes.length; i++) {
            nodes[i].style.fill = '#FFFFFF';
        }
        mapSvg.style.fill = '#6e1e82';
        buttonMap.classList.add('secondary');
        buttonList.classList.remove('secondary');
    }

    return {
        init: init
    }
}

loader.add('Premises', Premises);

export default Premises;